<template>
  <div class="el-section">
    <div
      class="emd-container _highlight_header _header_spaced _footer_spaced_sm"
      v-if="isLoading"
    >
      <section class="eu-pa_6 eu-align_center">
        <emd-loader type="_invert" />
      </section>
    </div>
    <invites-content
      v-else
      :isLoading="isLoading"
      :items="items"
      :pagination="pagination"
      :totalItems="totalItems"
      :action="action"
      :alert="alert"
      @openModal="openModal"
      @resetAlert="resetAlert"
    ></invites-content>
    <modal-password
      v-if="modalOpenned"
      @cancel="closeModal"
      :callback="actionInvite"
    ></modal-password>
  </div>
</template>
<script>
import { EmdLoader } from 'emerald-vue/src/components'
import { mapGetters } from 'vuex'
import InvitesContent from '@/views/Team/Invites/components/InvitesContent.vue'
import InvitesManager from '@/views/Team/Invites/invites.manager.js'
import { formatErrorMessage } from '../../../support/formatErrorMessage'
import ModalPassword from '@/components/project/globals/ModalPassword.vue'

export default {
  name: 'InvitesIndex',
  components: {
    EmdLoader,
    InvitesContent,
    ModalPassword
  },

  data () {
    return {
      action: 'GET_INVITES',
      modalOpenned: false,
      typeAction: false,
      invite: false,
      alert: {
        show: false,
        isError: false,
        messages: []
      }
    }
  },

  computed: {
    ...mapGetters(['loadingListInvites', 'invites']),
    isLoading () {
      return this.loadingListInvites ?? false
    },

    items () {
      const items = this.invites?.items ?? []
      return new InvitesManager(items).get()
    },

    pagination () {
      return this.invites?.pagination
    },

    totalItems () {
      return this.items?.length ?? 0
    }
  },

  methods: {
    openModal (invite, type) {
      this.modalOpenned = true
      this.invite = invite
      this.typeAction = type
    },

    closeModal () {
      this.modalOpenned = false
      this.invite = null
    },

    resetAlert () {
      this.alert = {
        show: false,
        isError: false,
        messages: []
      }
    },

    actionInvite (password) {
      this.resetAlert()

      const actionParams = {
        inviteId: this.invite.id,
        merchantId: this.$route.params.merchant_id,
        accountId: this.$route.params.account_id,
        body: { password }
      }
      const msgErrorInternal = this.$t('invite.error-internal')
      const messagesSuccess = {
        RESEND_INVITE: this.$t('invite.success-resend'),
        CANCEL_INVITE: this.$t('invite.success-cancel')
      }

      return this.$store
        .dispatch(this.typeAction, actionParams)
        .then(() => {
          this.alert = {
            show: true,
            isError: false,
            messages: [messagesSuccess[this.typeAction]]
          }
          this.$store.dispatch(this.action)
        })
        .catch(err => {
          this.alert = {
            show: true,
            isError: true,
            messages: formatErrorMessage(err, msgErrorInternal)
          }
          this.closeModal()
          this.getInvites()
          window.scrollTo(0, 0)
        })
    }
  }
}
</script>
